import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Box, Button, Column, IconButton, Typography } from 'seagull';
import { CloseCross } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './AiSearchPopoverPanel.module.scss';
export const GetAiSearchPopoverPanelTID = (parentTestId)=>getTestIds(parentTestId);
export const AiSearchPopoverPanel = (param)=>{
    let { testId, title, onClose, applyText, onApply, closeBiName, applyBiName, children, pinnedTop, applyDisabled = false } = param;
    const { AiSearchPopoverPanelTestIds } = useMemo(()=>GetAiSearchPopoverPanelTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Box, {
        testId: AiSearchPopoverPanelTestIds.Root(),
        className: styles.panel,
        children: [
            /*#__PURE__*/ _jsx(Box, {
                className: styles.closeButtonContainer,
                children: /*#__PURE__*/ _jsx(IconButton, {
                    testId: AiSearchPopoverPanelTestIds.Close(),
                    bi: {
                        name: closeBiName
                    },
                    onClick: onClose,
                    size: "small",
                    children: /*#__PURE__*/ _jsx(CloseCross, {
                        size: 10
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                testId: AiSearchPopoverPanelTestIds.Title(),
                variant: "paragraph1",
                skin: "secondary",
                children: title
            }),
            pinnedTop != null && /*#__PURE__*/ _jsx(Box, {
                className: styles.pinnedTop,
                children: pinnedTop
            }),
            /*#__PURE__*/ _jsx(Column, {
                gap: 20,
                alignItems: "stretch",
                className: styles.scroll,
                children: children
            }),
            /*#__PURE__*/ _jsx(Button, {
                testId: AiSearchPopoverPanelTestIds.Apply(),
                bi: {
                    name: applyBiName
                },
                onClick: onApply,
                disabled: applyDisabled,
                fluid: true,
                children: applyText
            })
        ]
    });
};
